import { Box, Grid } from "@mui/material/index";
import CBTaxCodeSearchFilter from "../filters/CBTaxCodeSearchFilter";
import CBVatNumberSearchFilter from "../filters/CBVatNumberSearchFilter";
import CBResetFiltersButton from "../buttons/CBResetFiltersButton";
import CBSearchButton from "../buttons/CBSearchButton";
import CBEmailSearchFilter from "../filters/CBEmailSearchFilter";
import CBBusinessNameSearchFilter from "../filters/CBBusinessNameSearchFilter";
import CBCustomerIdentifierSearchFilter from "../filters/CBCustomerIdentifierSearchFilter";

interface CBOrganizationSearchProps {
    onReset: () => void
}

const CBOrganizationSearch = ({
    onReset
}: CBOrganizationSearchProps) => {

    return (
        <Box>
            <Grid container spacing={2} alignItems="center">
                <Grid item lg={2.5} md={6} xs={12}>
                    <CBTaxCodeSearchFilter />
                </Grid>
                <Grid item lg={2.5} md={6} xs={12}>
                    <CBVatNumberSearchFilter />
                </Grid>
                <Grid item lg={2.5} md={6} xs={12}>
                    <CBBusinessNameSearchFilter />
                </Grid>
                <Grid item lg={2.5} md={6} xs={12}>
                    <CBEmailSearchFilter />
                </Grid>
                <Grid item container lg={2} md={6} xs={12} display="flex-end" alignItems="center">
                    
                    <Grid item xs={6} >
                        <CBResetFiltersButton onClick={onReset} />
                    </Grid>
                    <Grid item xs={3}/>
                    <Grid item xs={2} >
                        <CBSearchButton />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )

}

export default CBOrganizationSearch;